import Vue from "vue";
import Loader from "@/components/Loader.vue";
import Navbar from "@/components/Navbar.vue";
import Footr from "@/components/Footr.vue";

Vue.component("loader", Loader);
Vue.component("navbar", Navbar);
Vue.component("footr", Footr);
